import * as React from 'react';
import {
  setPlanesDesdeBusqueda,
  setPlanes,
  setDataGrupoCopy
} from '../../actions/planesActions';
import { connect } from 'react-redux';
import { getPlanesPorParametros } from '../../api/axios';
import ReactPaginate from 'react-paginate';


class Busqueda extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      IdPlataforma: 0,
      Numero: null,
      IdPlan: null,
      NumeroPagina: 1,
      CantidadPagina: 10,
      CantidadTotal: 0,
      Descripcion: "",
      planes: [],
      planesToSend: []
    }
  };

  componentDidMount() {
    this.requestChange();
    this.props.setDataGrupoCopy(this.props.dataGrupo);
    if (this.props.idGrupo == 0) {
      this.props.setPlanesDesdeBusqueda([]);
      this.props.setPlanes([]);
    } else {
      if (this.props.idGrupo == "Nuevo") {
        this.props.setPlanes([]);
      }
      let jsonPlanDesdeBusqueda = JSON.stringify(this.props.planDesdeBusqueda);
      if (jsonPlanDesdeBusqueda != "[]") {
        this.format_PlanesEnGrupo(this.props.planDesdeBusqueda);
      } else {
        this.format_PlanesEnGrupo(this.props.planesEnGrupo);
      }
    }
  }

  format_PlanesEnGrupo = (listaObjeto) => {

    let newArr = [];
    if (listaObjeto != undefined) {
      for (let index = 0; index < listaObjeto.length; index++) {
        const element = listaObjeto[index];
        let newObj = {
          numero: element.numeroPlan != null ? element.numeroPlan : element.numero,
          descripcion: element.descripcion,
          cuotas: element.cuotas,
          id: element.idPlan != null ? element.idPlan : element.id
        }
        newArr.push(newObj);
      }
      this.setState({ planesToSend: newArr });
      this.props.setPlanesDesdeBusqueda(newArr);
    }
  }

  addToPlanes = (params) => {
    let arrayEstado = [];
    arrayEstado = this.state.planesToSend;
    let repetido = arrayEstado.some(x => x.numero == params.numero);

    if (repetido) {
      let index = arrayEstado.findIndex(x => x.numero == params.numero);
      if (index !== undefined) {
        arrayEstado.splice(index, 1);
        this.setState({ planesToSend: arrayEstado });
        document.getElementById("check" + params.numero).checked = false;
      }
    }
    else {
      arrayEstado.push(params);
      this.setState({ planesToSend: arrayEstado });
      document.getElementById("check" + params.numero).checked = true;
    }

    this.props.setPlanesDesdeBusqueda(this.state.planesToSend);
  }

  agregarPlanes = () => {
    if (this.props.editando) {
      this.props.history.push(`/Planes/Editar/${this.props.idGrupo}`);
    } else {
      this.props.history.push("/Planes/Nuevo");
    }
  }

  handlePageClick = (e) => {
    const selectedPage = e.selected + 1;
    this.setState({ NumeroPagina: selectedPage });
    this.requestChange();
  };

  myChangeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    this.requestChange();
  }

  requestChange = () => {
    setTimeout(() => {
      let params = {
        IdPlataforma: 1,
        Numero: this.state.Numero,
        IdPlan: this.state.IdPlan,
        NumeroPagina: this.state.NumeroPagina,
        CantidadPagina: this.state.CantidadPagina,
        Descripcion: this.state.Descripcion
      }
      let listaPlanes = getPlanesPorParametros(params);
      listaPlanes.then((res) => {
        this.setState({
          planes: res.data?.elementos ?? [],
          CantidadTotal: res.data.cantidadTotal,
          NumeroPagina: res.data.numeroPagina
        })
        this.comprobarCheckbox();
      })
    }, 500)
  }

  comprobarCheckbox = () => {
    let planChecked = [];
    let plan = [];
    let idsIniciales = this.state.planesToSend;
    setTimeout(() => {
      for (let i = 0; i < this.props.planDesdeBusqueda.length; i++) {
        planChecked.push("check" + this.props.planDesdeBusqueda[i].numero);
        let obj = this.props.planDesdeBusqueda[i];
        let repetido = idsIniciales.some(item => item.numero == obj.numero);
        if (!repetido) {
          idsIniciales.push(obj);
        }
      }

      this.setState({ planesToSend: idsIniciales });

      var inputs = document.getElementsByName('checkBoxes');
      for (let i = 0; i < inputs.length; i++) {
        let element = inputs[i].id;
        plan.push(element);
      }
      for (let i = 0; i < plan.length; i++) {
        document.getElementById(plan[i]).checked = false;
      }
      for (let i = 0; i < planChecked.length; i++) {
        for (let c = 0; c < plan.length; c++) {
          if (plan[c] == planChecked[i]) {
            document.getElementById(plan[c]).checked = true;
          }
        }
      }
    }, 50)
  }

  onSubmit = async (event) => {
    event.preventDefault();
  }

  return = () => {
    this.props.setPlanesDesdeBusqueda([]);
    this.props.history.push("/Planes");
  }


  render() {
    return (
      <div className="container">
        <div className="col-12 card">

          <div className="card-body p-b-0">
            <h4 className="card-title col-12">Busqueda de planes</h4>
          </div>

          <div className="row form-material p-4 p-md-0">
            <div className="col-12 col-md-3 offset-md-1">
              <label className="label-oscura">Número Plan</label>
              <input
                onChange={this.myChangeHandler}
                name="Numero"
                type="number"
                className="form-control"
              />
            </div>
            <div className="col-12 col-md-4 col-12 col-md-1">
              <label className="label-oscura">Descripcion</label>
              <input
                onChange={this.myChangeHandler}
                className="form-control"
                name="Descripcion"
                type="text"
              />
            </div>
          </div>

          <form className="form-horizontal form-material p-10" onSubmit={this.onSubmit}>
            <div className="tab-content table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Número plan</th>
                    <th>Descripcion plan</th>
                    <th>Seleccionar</th>
                  </tr>
                </thead>
                <tbody>
                {this.state.planes &&
                  this.state.planes.map((plan) => (
                    <tr
                      className="hover-background-color allow-pointer-cursor"
                      onClick={() => this.addToPlanes(plan)}
                      key={plan.numero}
                    >
                      <td>{plan.numero}</td>
                      <td>{plan.descripcion}</td>
                      <td className="custom-control custom-checkbox">
                        <input
                          name="checkBoxes"
                          onChange={(e) => e.stopPropagation()}
                          defaultValue={false}
                          type="checkbox"
                          className="custom-control-input allow-pointer-cursor"
                          id={"check" + plan.numero}
                        />
                      </td>
                    </tr>
                  ))
                }
                </tbody>
              </table>

              <div className="d-flex justify-content-center">
                <ReactPaginate
                  previousLabel={"Anterior"}
                  nextLabel={"Siguiente"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={this.state.CantidadTotal / this.state.CantidadPagina}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                  forcePage={0}
                />
              </div>

              <div className="d-flex justify-content-center">
                <button
                  onClick={() => this.agregarPlanes()}
                  className="btn btn-sm background-rojo-megatone waves-light m-r-10"
                >
                  Guardar
                </button>

                <button
                  onClick={this.return}
                  className="btn btn-sm btn-light waves-effect waves-light"
                >
                  Salir
                </button>
              </div>

            </div>
          </form>

        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  planes: state.planes,
  planesEnGrupo: state.planes.grupoPorId.elementos,
  idGrupo: state.planes.id,
  planDesdeBusqueda: state.planes.planesDesdeBusqueda,
  editando: state.general.editando,
  dataGrupo: state.planes.dataGrupo,
});

export default connect(mapStateToProps, {
  setPlanesDesdeBusqueda,
  setPlanes,
  setDataGrupoCopy
})(Busqueda); 